import React, { useCallback, useContext } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { scrollIntoViewWithHeader } from '../../../../utils/scrollIntoViewWithHeader';
import ArrowDown from '@wix/da-ds/pkg/Icons/ArrowDown';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import Button from '../../../../Button';
import { HEADER_HEIGHT_TO_SKIP_WHEN_SCROLLING, PX_SCROLLED_BEFORE_SHOWING_SCROLL_TO_NEXT, } from '../../constants';
import s from './ScrollToNextPostButton.scss';
var ScrollToNextPostButton = function (_a) {
    var className = _a.className, buttonClassName = _a.buttonClassName, isDisplayed = _a.isDisplayed, scrollTarget = _a.scrollTarget, biData = _a.biData, _b = _a.extraYWhenScrolling, extraYWhenScrolling = _b === void 0 ? HEADER_HEIGHT_TO_SKIP_WHEN_SCROLLING : _b, _c = _a.pxScrolledBeforeShowing, pxScrolledBeforeShowing = _c === void 0 ? PX_SCROLLED_BEFORE_SHOWING_SCROLL_TO_NEXT : _c;
    var t = useTranslation().t;
    var isMobile = useContext(MobileContext);
    var scrollToTarget = useCallback(function () {
        var scrollTargetNode = scrollTarget.current;
        scrollTargetNode &&
            scrollIntoViewWithHeader(scrollTargetNode, isMobile, extraYWhenScrolling, undefined, true, true);
    }, [scrollTarget, isMobile, extraYWhenScrolling]);
    return isDisplayed ? (React.createElement("div", { className: classnames(s['scroll-to-next-container'], className), style: { top: pxScrolledBeforeShowing } },
        React.createElement(Button, { view: "b19", className: classnames(s['scroll-to-next-btn'], buttonClassName), onClick: scrollToTarget, biData: biData },
            React.createElement(ArrowDown, { className: s['scroll-to-next-btn-icon'], size: IconSize.SMALL }),
            t('deviationview.journal.skipToNextButton')))) : null;
};
ScrollToNextPostButton.displayName = 'ScrollToNextPostButton';
export default ScrollToNextPostButton;
//# sourceMappingURL=ScrollToNextPostButton.js.map